/**
 * Sidebar Icon
 *
 */

import React from 'react'

export default function change_log(props = {}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.5 21.75C15.4284 21.75 17.3134 21.1782 18.9168 20.1068C20.5202 19.0355 21.7699 17.5127 22.5078 15.7312C23.2458 13.9496 23.4389 11.9892 23.0627 10.0979C22.6865 8.20656 21.7579 6.46928 20.3943 5.10571C19.0307 3.74215 17.2934 2.81355 15.4021 2.43735C13.5108 2.06114 11.5504 2.25422 9.76884 2.99218C7.98726 3.73013 6.46452 4.97982 5.39317 6.58319C4.32183 8.18657 3.75 10.0716 3.75 12V13.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 14H12V8"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.75 10.5L3.75 13.5L6.75 10.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
